import { Component, OnInit } from '@angular/core';
import { VenueService } from '../../../services/VenueService';
import { Apiservice } from '../../../services/ApiService';
import { StorageService } from '../../../services/StorageService';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ChartData } from 'chart.js';

@Component({
  selector: 'app-feeds',
  templateUrl: './feeds.component.html',
  styleUrls: ['./feeds.component.scss', '../styles/shared.scss']
})
export class FeedsComponent implements OnInit {

  loading: boolean = false;
  Selectedvenue: string = '';
  venueValue: string = '';
  venuelist: any[] = [];
  date: string = '';
  isModalOpen: boolean = false;
  deliveryList: any = [];
  deliveryOptions: any = [];
  noFeeds: boolean = false;
  fieldsdisabled: boolean = true;
  bucket: string = '';
  columns: string = '';
  deliveryName: string = '';
  type: string = '';
  postdata: any = [];
  active: string = 'YES';
  status: string = 'PENDING';
  feedKey: string = '';
  addFeedType: string = '';
  path: string = '';
  server: string = '';
  username: string = '';
  password: string = '';
  url: string = '';
  eventBUS: string = '';
  stream: string = '';
  currentDate = new Date(new Date().getTime() + 14 * 3600 * 1000)
  .toISOString()
  .replace(/ GMT$/, '')
  .split('T')[0];
  dateFilters: string[] = [];
  sendDates: string[] = [];
  dates: string = '';
  editingTimeFor: { deliveryPointKey: string; dateKey: string } | null = null;
  editStart: string = '';
  editEnd: string = '';
  editDisplay: boolean = false;
  dsnInput: string = '';
  dsnList: string[] = [];
  venueTimezone: string = '';
  latencyChartData: ChartData = {
    labels: [],
    datasets: [],
  };
  latencyChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
    },
    scales: {
      x: { title: { display: true, text: 'Time' } },
      y: { title: { display: true, text: 'Avg Latency (seconds)' } },
    },
  };


  constructor(private _http: HttpClient,private storage: StorageService,private router: Router,public venue: VenueService, private apiservice: Apiservice) {}


  onVenueChange(){
    this.storage.saveVenue(this.Selectedvenue);
    const selectedVenueObj = this.venuelist.find(venue => venue.key === this.Selectedvenue);
    this.venueValue = selectedVenueObj ? selectedVenueObj.value: '';
    this.venueTimezone = (this.venueValue as any)?.timezone;
    this.getDeliveryFeeds();
    this.getdeliveryOptions();
  }

  onDateChange(){
      this.storage.saveDate(this.date);
    }

  getVenueList(){
    this.venue.getVenueList().subscribe((data:any) => {
      this.venuelist = data;
      const selectedVenueObj = this.venuelist.find(venue => venue.key === this.Selectedvenue);
      this.venueValue = selectedVenueObj ? selectedVenueObj.value : '';
      this.venueTimezone = (this.venueValue as any)?.timezone;
      this.getDeliveryFeeds();
      this.getdeliveryOptions();
    });
  }



  getDeliveryFeeds() {
    this.loading = true;
    this.apiservice.getDeliveryFeeds(this.Selectedvenue).subscribe({
      next: (result: any) => {
        this.normalizeDateFilters(result);
        this.deliveryList = result;
        this.buildLatencyChart(result.deliveryLatency ?? []);
      },
      error: (err) => {
        console.error("Error fetching delivery feeds", err);
      },
      complete: () => {
        this.loading = false;
        console.log(this.deliveryList);
      },
    });
  }
  
  getdeliveryOptions() {
    this.loading = true;
    this.apiservice.getDeliveryOptions().subscribe({
      next: (result: any) => {
        this.deliveryOptions = result;
        this.columns = this.deliveryOptions.availableFields;
      },
      error: (err) => {
        console.error("Error fetching delivery options", err);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  addGatePath(){
    this.router.navigate(['feeds/add'], { state: { Selectedvenue: this.Selectedvenue, deliveryOptions: this.deliveryOptions, deliveryList: this.deliveryList, venueTimezone: this.venueTimezone  } });
  }

  sendAttendance() {
    this.loading = true
    const body = {
      venue: this.Selectedvenue,
      date: this.date,
    };
    this._http
      .post(
        'https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/resend',
        body
      )
      .subscribe({
        next: (data) => {
          this.closeModal();
          this.loading = false;
        },
      });
  
    }

    testAllFeeds(venueid: string){
      this.loading = true;
      this._http.post('https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/delivery/test?venue='+ venueid, {}).subscribe({
        next: data => {
          this.postdata = data;
        },
        error: error => {
        },
        complete: () => {
          this.reloadPage();
          this.loading = false;
        },
      });
    }

    ResubmitFeed( venue: string, deliveryPoint: any){
      this.loading = true;
      this._http.post('https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/delivery/resubmit?venue='+ venue + '&deliveryName=' + deliveryPoint, {}).subscribe({
        next: data => {
          this.postdata = data;
        },
        error: error => {
          
        },
        complete: () => {
          this.reloadPage();
        },
      })
      }

    reloadPage() {
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  

  setEditDisplay(){ 
    this.fieldsdisabled = false;
    this.editDisplay = true;
   
  }

  editfeed() {
    console.log(this.deliveryList);
    this.editDisplay = false;
    this._http.post(' https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/delivery', this.deliveryList).subscribe({
      next: data => {
        this.postdata = data;
        this.fieldsdisabled = true;
      },
  
      error: error => {
      
      }
  })}

  addDate(event: any, deliveryPointKey: string): void {
    event.preventDefault();

    const rawValues = this.dates
      .split('\n')
      .map((v: string) => v.trim())
      .filter((v: string) => v);

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    const invalidDates: string[] = [];

    const deliveryPoint = this.deliveryList.deliveryPoints.find(
      (dp: { deliveryName: string }) => dp.deliveryName === deliveryPointKey
    );

    if (deliveryPoint) {
      if (!deliveryPoint.datefilters || Array.isArray(deliveryPoint.datefilters)) {
        deliveryPoint.datefilters = {};
      }

      rawValues.forEach((dateStr: string) => {
        if (!dateRegex.test(dateStr)) {
          invalidDates.push(dateStr);
          return;
        }
        deliveryPoint.datefilters[dateStr] = {};
      });
    }

    if (invalidDates.length) {
      alert(`These dates are invalid: ${invalidDates.join(', ')}`);
    }

    this.dates = '';
  }

  getDates(event:any){
    this.dates = event.target.value;
  }

  removeChip(deliveryPointKey: string, dateKey: string): void {
    const deliveryPoint = this.deliveryList.deliveryPoints.find(
      (dp: { deliveryName: string; }) => dp.deliveryName === deliveryPointKey
    );

    if (deliveryPoint && deliveryPoint.datefilters && !Array.isArray(deliveryPoint.datefilters)) {
      delete deliveryPoint.datefilters[dateKey];
    }
  }
  
  removeSendChip(index: number): void {
    this.sendDates.splice(index, 1);
  }

  getDsnValue(event: any) {
    this.dsnInput = event.target.value;
    console.log(this.dsnInput);
  }

  removeDsn(deliveryPointKey: string, chipIndex: number): void {
    const deliveryPoint = this.deliveryList.deliveryPoints.find(
      (dp: { deliveryName: string; }) => dp.deliveryName === deliveryPointKey
    );
    
    if (deliveryPoint && deliveryPoint.datefilters) {
      deliveryPoint.dsnfilters.splice(chipIndex, 1);
    }
  }

  addDsn(event: any, deliveryPointKey: string): void {
    event.preventDefault();
  
    const newDsn = this.dsnInput.trim();
    const deliveryPoint = this.deliveryList.deliveryPoints.find(
      (dp: { deliveryName: string }) => dp.deliveryName === deliveryPointKey
    );
  
    if (deliveryPoint) {
      if (!deliveryPoint.dsnfilters) {
        deliveryPoint.dsnfilters = [];
      }
  
      if (newDsn && !this.dsnList.includes(newDsn)) {
        this.dsnList.push(newDsn);
        deliveryPoint.dsnfilters.push(newDsn);
        console.log('DSN List:', this.dsnList);
      }
    }
  
    this.dsnInput = '';
  }

 

  hasDateFilters(deliveryPoint: any): boolean {
    const df = deliveryPoint?.datefilters;
    if (!df) return false;
    if (Array.isArray(df)) return df.length > 0;
    return Object.keys(df).length > 0;
  }

  isTimeRange(value: any): boolean {
    return Array.isArray(value) && value.length === 2;
  }

  formatTimeRange(value: any): string {
    if (!this.isTimeRange(value)) return '';
    return `${this.formatEpochTime(value[0])} – ${this.formatEpochTime(value[1])}`;
  }

  formatEpochTime(epochSeconds: number): string {
    return this.epochToVenueTime(epochSeconds).time;
  }

  isEditingTimes(deliveryPointKey: string, dateKey: string): boolean {
    return (
      !!this.editingTimeFor &&
      this.editingTimeFor.deliveryPointKey === deliveryPointKey &&
      this.editingTimeFor.dateKey === dateKey
    );
  }

  startEditTimes(deliveryPointKey: string, dateKey: string, value: any): void {
    this.editingTimeFor = { deliveryPointKey, dateKey };
    if (this.isTimeRange(value)) {
      this.editStart = this.epochToVenueTime(value[0]).time;
      this.editEnd = this.epochToVenueTime(value[1]).time;
    } else {
      this.editStart = '';
      this.editEnd = '';
    }
  }

  saveEditTimes(deliveryPointKey: string, dateKey: string): void {
    const timeRegex = /^\d{2}:\d{2}$/;
    const hasStart = !!this.editStart;
    const hasEnd = !!this.editEnd;
    if (hasStart !== hasEnd) {
      alert('Both start and end time must be provided, or leave both empty for a full day.');
      return;
    }
    if (hasStart && (!timeRegex.test(this.editStart) || !timeRegex.test(this.editEnd))) {
      alert('Times must be in HH:MM format.');
      return;
    }
    const deliveryPoint = this.deliveryList.deliveryPoints.find(
      (dp: { deliveryName: string }) => dp.deliveryName === deliveryPointKey
    );
    if (!deliveryPoint || !deliveryPoint.datefilters || Array.isArray(deliveryPoint.datefilters)) {
      return;
    }
    if (hasStart) {
      const startEpoch = this.venueLocalToEpoch(dateKey, this.editStart);
      const endEpoch = this.venueLocalToEpoch(dateKey, this.editEnd);
      if (endEpoch <= startEpoch) {
        alert('End time must be after start time.');
        return;
      }
      deliveryPoint.datefilters[dateKey] = [startEpoch, endEpoch];
    } else {
      deliveryPoint.datefilters[dateKey] = {};
    }
    this.cancelEditTimes();
  }

  clearChipTimes(deliveryPointKey: string, dateKey: string): void {
    const deliveryPoint = this.deliveryList.deliveryPoints.find(
      (dp: { deliveryName: string }) => dp.deliveryName === deliveryPointKey
    );
    if (deliveryPoint && deliveryPoint.datefilters && !Array.isArray(deliveryPoint.datefilters)) {
      deliveryPoint.datefilters[dateKey] = {};
    }
    this.cancelEditTimes();
  }

  cancelEditTimes(): void {
    this.editingTimeFor = null;
    this.editStart = '';
    this.editEnd = '';
  }

  private normalizeDateFilters(result: any): void {
    const points = result?.deliveryPoints;
    if (!points) return;
    const keys = Array.isArray(points) ? points.map((_: any, i: number) => i) : Object.keys(points);
    keys.forEach((k: any) => {
      const dp = points[k];
      if (!dp) return;
      const df = dp.datefilters;
      if (Array.isArray(df)) {
        const obj: { [date: string]: {} } = {};
        df.forEach((d: string) => (obj[d] = {}));
        dp.datefilters = obj;
      } else if (!df || typeof df !== 'object') {
        dp.datefilters = {};
      }
    });
  }

  private epochToVenueTime(epochSeconds: number): { date: string; time: string } {
    const tz = this.venueTimezone || 'UTC';
    const parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date(epochSeconds * 1000));
    const lookup: any = {};
    parts.forEach((p) => (lookup[p.type] = p.value));
    const hour = lookup.hour === '24' ? '00' : lookup.hour;
    return {
      date: `${lookup.year}-${lookup.month}-${lookup.day}`,
      time: `${hour}:${lookup.minute}`,
    };
  }

  private venueLocalToEpoch(dateStr: string, timeStr: string): number {
    const [y, m, d] = dateStr.split('-').map(Number);
    const [h, min] = timeStr.split(':').map(Number);
    const asIfUTC = Date.UTC(y, m - 1, d, h, min);
    const parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: this.venueTimezone || 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(new Date(asIfUTC));
    const lookup: any = {};
    parts.forEach((p) => (lookup[p.type] = p.value));
    const hour = lookup.hour === '24' ? 0 : Number(lookup.hour);
    const asShown = Date.UTC(
      Number(lookup.year),
      Number(lookup.month) - 1,
      Number(lookup.day),
      hour,
      Number(lookup.minute),
      Number(lookup.second)
    );
    const offset = asShown - asIfUTC;
    return Math.floor((asIfUTC - offset) / 1000);
  }

  private buildLatencyChart(latencyData: { timestamp: string; average: number }[]): void {
    const timezone = this.venueTimezone || 'UTC';
    const formatOptions: Intl.DateTimeFormatOptions = {
      timeZone: timezone,
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    };
    this.latencyChartData = {
      labels: latencyData.map(d => new Date(d.timestamp).toLocaleString('en-AU', formatOptions)),
      datasets: [
        {
          data: latencyData.map(d => d.average),
          label: 'Avg Latency (seconds)',
          borderColor: '#1976d2',
          backgroundColor: 'rgba(25, 118, 210, 0.1)',
          fill: true,
          tension: 0.3,
        },
      ],
    };
  }

  addFeedTypeChangeHandler(event: any) {
    this.addFeedType = event.target.value.toUpperCase();
}





  openModal(): void {
    this.isModalOpen = true;
   
  }

  closeModal(): void {
    this.isModalOpen = false; 
   
  }

  ngOnInit(): void {
    this.loading= true;
    this.getVenueList();
    const savedVenue = this.storage.getVenue();
    if (savedVenue) {
      this.Selectedvenue = savedVenue;
    }
    if (this.Selectedvenue !== '') {
    const selectedVenueObj = this.venuelist.find(venue => venue.key === this.Selectedvenue);
    this.venueValue = selectedVenueObj ? selectedVenueObj.value : '';
  
  }
}



}
